import { FormSection } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSection';
import { IntegrationConnectorForm } from '@organisms';
import { FormSectionSummary } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSectionSummary';
import { Controller } from 'react-hook-form';
import { IntegrationConfigAppModelV2 } from '@api';
import { Control } from 'react-hook-form/dist/types/form';

export function ConnectorFormSection({
  config,
  control,
}: {
  config: IntegrationConfigAppModelV2;
  control: Control<{ selectedConnectorId: string }>;
}) {
  return (
    <FormSection
      summary={<FormSectionSummary title="Apono connector" tooltip="Select a connector to connect to Apono" />}
    >
      <Controller
        name="selectedConnectorId"
        control={control}
        render={({ field }) => (
          <IntegrationConnectorForm config={config} connectorId={field.value} onConnectorIdChange={field.onChange} />
        )}
      />
    </FormSection>
  );
}
